import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { USER_TYPE } from "../../../constants/common";
import classroomServices from "../../../services/classroomServices";
import { useNavigateWithLang } from "../../../utils/navigation";
import Button from "../../Button";
import CustomDataTable from "../../CustomDataTable";
import Modal from "../../Modal";

const TopFiveStudentsModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [classroomTopStudents, setClassroomTopStudents] = useState([]);
  const { id: classroomID } = useParams();
  const navigate = useNavigateWithLang();

  useImperativeHandle(ref, () => ({
    openModal() {
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const navigateStudentDetails = (id) => {
    navigate(`/${USER_TYPE.TEACHER.ROLE}/students/${classroomID}/${id}`);
  };

  const fetchClassroomTopStudents = async () => {
    try {
      const response = await classroomServices.getClassroomTopStudents(classroomID);

      setClassroomTopStudents(response);
    } catch (error) {
      console.error("Failed to fetch:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchClassroomTopStudents();
    }
  }, [isOpen]);

  const columns = [
    {
      name: t("name"),
      field: "student_name",
      sortable: true,
      body: (rowData) => (
        <Button
          tooltip={rowData.student_name}
          labelStyle="block w-80 overflow-hidden truncate whitespace-nowrap text-start"
          label={rowData.student_name}
          variant="link"
          color="blue"
          onClick={() => navigateStudentDetails(rowData.student_id)}
        />
      ),
    },
    {
      name: t("points"),
      field: "total_points",
      sortable: true,
    },
  ];

  return (
    <>
      <Modal
        footer={
          <div className="flex items-center justify-end space-x-2">
            <Button color="white" variant="outlined" onClick={handleCloseModal} label={t("cancel")} />
          </div>
        }
        isOpen={isOpen}
        onClose={handleCloseModal}
        className="w-full max-w-2xl px-0"
        contentClassname="p-0"
        header={<h3 className="text-2xl font-bold text-green-500">{t("top_five_students")}</h3>}
      >
        <CustomDataTable
          header={false}
          columns={columns}
          data={classroomTopStudents}
          withPagination={false}
          withSort
        />
      </Modal>
    </>
  );
});

export default TopFiveStudentsModal;
